module.exports = __webpack_public_path__ + "media/2022/yahoo-logo-e746edd3.svg";